var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "headDataForm",
                  attrs: {
                    model: _vm.headData,
                    "label-position": _vm.labelPosition,
                    "label-width": "140px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.no") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.applyNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "applyNo", $$v)
                                  },
                                  expression: "headData.applyNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.subject") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.subject,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "subject", $$v)
                                  },
                                  expression: "headData.subject",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "入围供应商" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.supplierNames,
                                  callback: function ($$v) {
                                    _vm.supplierNames = $$v
                                  },
                                  expression: "supplierNames",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.quotationType") } },
                            [
                              _c("ic-select", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "true",
                                  table: "TT_QUOTATION_APPLY",
                                  field: "QUOTATION_TYPE",
                                },
                                model: {
                                  value: _vm.headData.quotationType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "quotationType", $$v)
                                  },
                                  expression: "headData.quotationType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "历史报价", name: "line" } },
                _vm._l(_vm.roundList, function (round, i) {
                  return _c(
                    "div",
                    { key: i },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 16 } },
                        [
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.round")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 1 } }, [
                            _vm._v(_vm._s(round.roundNumber)),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("apply.quoteSubmitDate")) + "："
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c("el-link", [
                                _vm._v(" " + _vm._s(round.submitDate) + " "),
                              ]),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.roundRemark")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 4 } }, [
                            _vm._v(_vm._s(round.remark)),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAttachmentDialogM(
                                        _vm.$t("apply.roundAttachment"),
                                        round.ttQuotationApplyRoundId,
                                        "QUOTATION_APPLY_ROUND"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.roundAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAttachmentDialogM(
                                        _vm.$t("apply.quoteAttachment"),
                                        round.ttQuotationId,
                                        "QUOTATION",
                                        _vm.tmSupplierId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.quoteAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ux-grid",
                        {
                          ref: "quotationLineTableDataRef",
                          refInFor: true,
                          attrs: {
                            data: round.quotationProductList,
                            "keep-source": "",
                            "highlight-current-row": "",
                            "max-height": "550",
                            "show-overflow": "tooltip",
                          },
                        },
                        [
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _vm._l(_vm.columns, function (item, index) {
                            return _c("ux-table-column", {
                              key: index,
                              attrs: {
                                align: "center",
                                resizable: "",
                                field: item.prop,
                                title: item.label,
                                sortable: "",
                                "min-width": item.width,
                              },
                            })
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              resizable: "",
                              field: "isSpecialFreight",
                              title: "非标准线路运费",
                              sortable: "",
                              "min-width": "150",
                              formatter: _vm.formatisSpecial,
                            },
                          }),
                          _vm._l(_vm.columns1, function (item, index) {
                            return _c("ux-table-column", {
                              key: index,
                              attrs: {
                                align: "center",
                                resizable: "",
                                field: item.prop,
                                title: item.label,
                                sortable: "",
                                "min-width": item.width,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.showAttachmentDialog,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAttachmentDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.attachmentList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "documentName",
                  label: "文件",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.documentName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "userName",
                  label: "创建人",
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "createDate",
                  label: "创建时间",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatFilter")(
                                scope.row.createDate,
                                "YYYY-MM-DD HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }